import React, { useEffect, useState } from "react";
import MatchdayPill from "./MatchdayPill";
import "./tournamentBar.scss";

// 2026 FIFA World Cup opening match — Estadio Azteca, Mexico City (11 June 2026).
export const WC2026_KICKOFF = new Date("2026-06-11T19:00:00Z");

interface Remaining {
  days: number;
  hours: number;
  minutes: number;
  seconds: number;
}

function getRemaining(target: Date): Remaining | null {
  const diff = target.getTime() - Date.now();
  if (diff <= 0) return null;
  const total = Math.floor(diff / 1000);
  return {
    days: Math.floor(total / 86400),
    hours: Math.floor((total % 86400) / 3600),
    minutes: Math.floor((total % 3600) / 60),
    seconds: total % 60,
  };
}

const pad = (n: number) => n.toString().padStart(2, "0");

interface TournamentBarProps {
  /** Compact single-line variant for the mobile header. */
  compact?: boolean;
  /** Chrome-less variant for embedding inside the desktop header row. */
  inline?: boolean;
}

const TournamentBar: React.FC<TournamentBarProps> = ({ compact, inline }) => {
  const [remaining, setRemaining] = useState<Remaining | null>(() =>
    getRemaining(WC2026_KICKOFF)
  );

  useEffect(() => {
    const id = setInterval(() => setRemaining(getRemaining(WC2026_KICKOFF)), 1000);
    return () => clearInterval(id);
  }, []);

  return (
    <div
      className={`tournamentBar${compact ? " tournamentBar--compact" : ""}${
        inline ? " tournamentBar--inline" : ""
      }`}
    >
      <span className="tournamentBar__brand">
        {compact ? "WC 2026" : "FIFA World Cup 2026"}
      </span>

      {!compact && (
        <span className="tournamentBar__hostsGroup">
          <span className="tournamentBar__dot">•</span>
          <span className="tournamentBar__hosts">Canada · Mexico · USA</span>
        </span>
      )}

      <span className="tournamentBar__countdownGroup">
        <span className="tournamentBar__dot">•</span>
        {remaining ? (
          <span className="tournamentBar__countdown">
            {!compact && <span className="tournamentBar__label">Kicks off in</span>}
            <Unit value={remaining.days} label="Days" />
            <Unit value={pad(remaining.hours)} label="Hrs" />
            <Unit value={pad(remaining.minutes)} label="Min" />
            <Unit value={pad(remaining.seconds)} label="Sec" />
          </span>
        ) : (
          <MatchdayPill compact={compact} />
        )}
      </span>
    </div>
  );
};

const Unit: React.FC<{ value: number | string; label: string }> = ({
  value,
  label,
}) => (
  <span className="tournamentBar__unit">
    <span className="tournamentBar__num">{value}</span>
    <span className="tournamentBar__unitLabel">{label}</span>
  </span>
);

export default TournamentBar;
